import Meta from '../../components/common/Meta';
import RedesignPageLayout from '../../components/common/RedesignPageLayout';
import AdminBlogRequestAdd from '../../components/admin/AdminBlogRequestAdd';

const meta = {
    title: '提交博客 - 管理页面 - 博客中心',
    keywords: '管理页面',
    description: '管理页面',
};

export default function AdminBlogRequestAddPage() {
    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <header className="redesign-page-header">
                    <h1 className="redesign-page-title">提交博客</h1>
                    <p className="redesign-page-desc">管理后台 — 代用户提交博客收录申请。</p>
                </header>
                <AdminBlogRequestAdd />
            </RedesignPageLayout>
        </>
    );
}
